import type { Message } from '@hooks/useChat';

/** Quick non-global check for whether content contains a step execution line. */
export const hasStepExec = (text: string) =>
  /\*\*Executing step [\w-]+\*\*\s*\[\w+\]:/.test(text);

/** True when the message carries multi-agent metadata only historical
 *  conversations can have. */
export const isLegacyMultiAgentMessage = (message: Message): boolean =>
  !!message.agentBoundaries?.length || hasStepExec(message.content ?? '');
